import {renderApp} from './renderApp'
import {authService, scheduleRepository, cloudFunctionsService, sessionService} from './firebase'
import reportWebVitals from './reportWebVitals'

renderApp({authService, scheduleRepository, cloudFunctionsService, sessionService})
reportWebVitals(console.log)
